const React = require("react");
const PropTypes = require("prop-types");

const Pane = ({ children }) => {
  return <div className="pane">{children}</div>;
};

Pane.propTypes = {
  children: PropTypes.node.isRequired,
};

module.exports = Pane;
